import Campaign from '../store/Campaign';
import { campaignStore } from '../store/store';

export const getCampaignObjectsCache = (placementId: string): Campaign<any>[] =>
    campaignStore.campaignObjectsCache[placementId];
